import { render } from "./SemanticVersion.vue?vue&type=template&id=191f173e"
import script from "./SemanticVersion.vue?vue&type=script&lang=js"
export * from "./SemanticVersion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__